module.exports = __webpack_public_path__ + "img/6.d0f2390c.jpg";